import { getStationaryBookingProgress } from '@components/BookingFlow/Common/bookingFlowProgress';
import { ReservedTimeNotice } from '@components/BookingFlow/Stationary/ReservedTimeNotice';
import { StationaryLoginOrderDetails } from '@components/BookingFlow/Stationary/StationaryLoginOrderDetails';
import { StationaryReservationExpiredBanner } from '@components/BookingFlow/Stationary/StationaryReservationExpiredBanner';
import { CheckoutLoginStep } from '@components/Login/CheckoutLoginStep';
import { plural } from '@lingui/core/macro';
import { customerRoutes, formatCurrencyAmount } from 'noddi-util';
import { useCancelHoldOnExpiry } from 'noddi-web';
import { useStationarySummaryData } from '../../../../hooks/useStationarySummaryData';

export const StationaryBookingLogin = () => {
  const { isSummaryLoading, summaryError, reservation, serviceCenter, carDisplayName, lineItems, totalPrice } =
    useStationarySummaryData();
  // Keep credentials after client TTL so re-reserve can cancel-before-hold.
  const isReservationExpired = useCancelHoldOnExpiry(reservation);
  const total = formatCurrencyAmount({ money: { amount: totalPrice } });

  return (
    <CheckoutLoginStep
      progress={getStationaryBookingProgress('summary')}
      nextPath={customerRoutes.newStationaryBookingSummary.getPath()}
      isBookingFlow
      opensUserGroupPicker
      notice={reservation && !isReservationExpired && <ReservedTimeNotice reservation={reservation} />}
      blockedBy={
        (!reservation || isReservationExpired) && (
          <StationaryReservationExpiredBanner
            timeWindowPath={customerRoutes.newStationaryBookingTimeWindow.getPath()}
          />
        )
      }
      // The recap is optional here: a slow or failed summary must never hold up the login.
      isOrderLoading={isSummaryLoading}
      order={
        isSummaryLoading || summaryError
          ? undefined
          : {
              // The car leads the expanded details, so the collapsed line counts services instead.
              description: plural(lineItems.length, { one: '# service', other: '# services' }),
              total,
              details: (
                <StationaryLoginOrderDetails
                  carDisplayName={carDisplayName}
                  lines={lineItems}
                  locationName={serviceCenter?.name}
                  total={total}
                />
              )
            }
      }
    />
  );
};
